import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {UserControllerService} from '../services/user/user-controller.service';

@Injectable()
export class AuthGuardGuard implements CanActivate {

  constructor(private userCtrl: UserControllerService,
              private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.userCtrl.isLogged) {
      return true;
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/auth-guard.guard.ts